import useDefinedContext from "hooks/useDefinedContext";
import RoleContext from "../RoleContext";

function useRole() {
  return useDefinedContext(RoleContext);
}

export default useRole;
